import { defineMessages } from 'react-intl';

export default defineMessages({
  aroundMe: {
    id: 'components.myaccount.claims.handling.pickup.aroundMe',
    defaultMessage: 'around me',
  },
  searchPlaces: {
    id: 'components.myaccount.claims.handling.pickup.searchPlaces',
    defaultMessage: 'Search places',
  },
});
